import { render, staticRenderFns } from "./AdventResourceDialog.vue?vue&type=template&id=0017c319&scoped=true&"
import script from "./AdventResourceDialog.vue?vue&type=script&lang=js&"
export * from "./AdventResourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdventResourceDialog.vue?vue&type=style&index=0&id=0017c319&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017c319",
  null
  
)

export default component.exports